export const glowVertexShader = `
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;

export const glowFragmentShader = `
  uniform float uTime;
  uniform vec2 uPointer;
  uniform float uFade;
  varying vec2 vUv;

  // Soft radial glow blob
  float blob(vec2 uv, vec2 center, float radius) {
    float d = length(uv - center);
    return exp(-(d * d) / (radius * radius));
  }

  void main() {
    // Keep aspect roughly square so blobs stay round
    vec2 uv = vec2(vUv.x * 1.6, vUv.y);
    float t = uTime * 0.08;
    float s = 0.5 + 0.5 * sin(uTime * 0.22);
    vec2 par = uPointer * 0.02;

    // Starting layout like the reference (teal upper-left, blue right, violet
    // lower-right, pink lower-left). Colors sweep across the screen on a slow
    // automatic loop instead of following scroll.
    float sw = sin(s * 3.14159);
    vec2 cTeal   = vec2(0.18 + sin(t * 1.1) * 0.14 + s * 1.2,  0.85 + cos(t * 0.8) * 0.10 - s * 0.5) + par;
    vec2 cBlue   = vec2(1.38 + cos(t * 0.7) * 0.16 - s * 1.2,  0.62 + sin(t * 1.0) * 0.14 - sw * 0.25) + par * 1.4;
    vec2 cViolet = vec2(1.25 + sin(t * 0.9 + 2.0) * 0.14 - sw * 0.55, 0.15 + cos(t * 1.2 + 1.0) * 0.10 + s * 0.6) + par;
    vec2 cPink   = vec2(0.35 + cos(t * 0.8 + 4.0) * 0.16 + sw * 0.55, 0.20 + sin(t * 0.6 + 3.0) * 0.10 + sw * 0.4) + par * 0.7;

    vec3 teal   = vec3(0.20, 0.65, 0.50);
    vec3 blue   = vec3(0.30, 0.45, 0.95);
    vec3 violet = vec3(0.45, 0.28, 0.80);
    vec3 pink   = vec3(0.85, 0.35, 0.55);

    vec3 col = vec3(0.0);
    col += teal   * blob(uv, cTeal,   0.42) * 0.30;
    col += blue   * blob(uv, cBlue,   0.46) * 0.34;
    col += violet * blob(uv, cViolet, 0.38) * 0.26;
    col += pink   * blob(uv, cPink,   0.30) * 0.16;

    // Very slow breathing so the gradient feels alive even when idle
    col *= 0.9 + sin(uTime * 0.35) * 0.1;

    // Gentle fade only at the outermost edges of the plane
    float edge = smoothstep(0.0, 0.08, vUv.x) * smoothstep(1.0, 0.92, vUv.x)
               * smoothstep(0.0, 0.06, vUv.y) * smoothstep(1.0, 0.94, vUv.y);

    // Darken the center band a bit so hero text stays readable
    float centerGuard = 1.0 - 0.18 * blob(uv, vec2(0.8, 0.55), 0.45);

    gl_FragColor = vec4(col * centerGuard, edge * uFade);
  }
`;
